<template>
    <b-input 
        class="interior-search-input is-hidden-desktop" 
        type="text" 
        :value="value"
        @input="handleInput"
        @keyup.enter.native="handleSearch" 
        @keydown.down.prevent.native="moveDown" 
        @keydown.up.prevent.native="moveUp"
        ref="input" 
        placeholder="Ej: Certificado de nacimiento" 
        icon-pack="fas" 
        :icon-right="value ? 'times' : ''"
        @icon-right-click="handleInput('')" 
        icon-right-clickable
    />
</template>

<script>
export default {
    name: 'MobileSearchInput',
    props: {
        value: {
            type: String,
            required: true
        }
    },
    methods: {
        handleInput(value) {
            this.$emit('input', value)
        },
        handleSearch() {
            this.$emit('search')
        },
        moveDown() {
            this.$emit('move-down')
        },
        moveUp() {
            this.$emit('move-up')
        }
    }
}
</script>